import Store from "@/store/store.js";

export const UPDATE_MEMBER = "updateMember";
export const UPDATE_SESSIONDATA = "updateSessionData";
export const UPDATE_COURSE = "updateCourse";
export const UPDATE_HALL = "updateHall";
export const UPDATE_HALL_MEETING = "updateHallMeeting";

export const GET_SESSIONDATA = "getSessionData";

export const RESET_STORE = "resetStore";

class StoreMutators {
  updateMember(memberToUpdate) {
    Store.commit(UPDATE_MEMBER, memberToUpdate);
  }

  updateSessionData(sessionData) {
    Store.commit(UPDATE_SESSIONDATA, sessionData);
  }

  updateCourse(courseToUpdate) {
    Store.commit(UPDATE_COURSE, courseToUpdate);
  }

  updateHall(hallToUpdate) {
    Store.commit(UPDATE_HALL, hallToUpdate);
  }

  updateHallMeeting(hallToWorkWith, meetingToUpdate) {
    Store.commit(UPDATE_HALL_MEETING, {hallToWorkWith, meetingToUpdate});
  }

  resetStore() {
    Store.commit(RESET_STORE);
  }
}

export var Mutators = new StoreMutators();
